module.exports = __webpack_public_path__ + "static/img/finciero_page.370b383.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/finciero_page.png
// module id = U45g
// module chunks = 1